import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class EnvConfigService {
  public config: any = {}; 
  public header =  {};
  public constructor(public http: HttpClient, public router: Router) {}

  public async Init(): Promise<void> {
    const url = window.location.origin + '/api/v1/envconfig';	
    this.config = await this.getConfig(url);
  }

  public setHttpHeader() {
    this.header =  {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
  }

  public getConfig(url:string): Promise<any> {
    return this.http.get(url,this.header).toPromise();
  }
}
